module.exports = __webpack_public_path__ + "img/psol.7ddf01ae.jpg";